import { actionTypes } from "./actions";

const initialState = {
  data: [],
  termPartners: [],
  termEdit: {},
  editFormViewStatus: false
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.SET_PAYMENT_TERMS:
      return {
        ...state,
        data: payload,
      };

    case actionTypes.SET_PAYMENT_PARTNERS:
      return {
        ...state,
        termPartners: payload,
      };

    case actionTypes.SET_TERMS_BY_ID:
      return {
        ...state,
        termEdit: payload,
      };

    case actionTypes.CLEAR_TERM:
      return {
        ...state,
        termPartners: []
      }

    case actionTypes.EDIT_FORM_VIEW_STATUS:
      return {
        ...state,
        editFormViewStatus: payload
      }

    default:
      return {
        ...state,
      };
  }
};
